export default "__VITE_ASSET__CgVoKjW8__"